export default function () {
  return {
    NAO_ONEROSO: {
      groups: [
        {
          legend: '01 - IDENTIFICAÇÃO DO PROCESSO',
          styleClasses: 'none',
          fields: [
            {
              column: 12,
              type: 'elementInput',
              model: 'numerosSei',
              inputName: 'numerosSei',
              visible: true,
              disabled: true,
              required: false,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'Nº SEI: ',
              clearable: true
            },
            {
              column: 12,
              type: 'elementInput',
              model: 'numeroProcesso',
              inputName: 'numeroProcesso',
              visible: true,
              disabled: true,
              required: false,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'Número do Processo: ',
              clearable: true
            }
          ]
        },
        {
          legend: '02 - INTERESSADO',
          codigo: 'INTERESSADO',
          styleClasses: 'none',
          fields: [
            {
              column: 24,
              type: 'elementInput',
              model: 'interessado.pessoa.nomeRazaoSocial',
              inputName: 'nomeRazaoSocial',
              visible: true,
              disabled: true,
              validator: 'required',
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'Nome do Interessado: ',
              clearable: true
            },
            {
              column: 12,
              type: 'elementInput',
              model: 'interessado.pessoa.pessoaFisica.gentilico',
              inputName: 'nacionalidade',
              visible: true,
              disabled: true,
              validator: 'required',
              required: true,
              valueKey: 'codigo',
              value: 'codigo',
              values: [],
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'Nacionalidade: ',
              clearable: true
            },
            {
              column: 12,
              type: 'elementInput',
              model: 'interessado.pessoa.pessoaFisica.profissao',
              inputName: 'profissao',
              visible: true,
              disabled: true,
              validator: 'required',
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'Profissão: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'interessado.pessoa.pessoaFisica.rg',
              inputName: 'numeroRg',
              visible: true,
              disabled: true,
              validator: 'required',
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'N° do RG: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'interessado.pessoa.pessoaFisica.ufRg',
              inputName: 'ufRg',
              visible: true,
              disabled: true,
              validator: 'required',
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'UF do RG: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'interessado.pessoa.cpfCnpj',
              inputName: 'cpfCnpj',
              visible: true,
              disabled: true,
              validator: 'required',
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'CPF/CNPJ: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'domicilio',
              inputName: 'domicilio',
              visible: true,
              disabled: true,
              required: false,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'Domicílio: ',
              clearable: true
            }
          ]
        },
        {
          legend: '03 - INFORMAÇÃO DO IMÓVEL',
          codigo: 'INFORMACOES_IMOVEIS',
          styleClasses: 'none',
          fields: [
            {
              column: 6,
              type: 'elementInput',
              model: 'imovel.area',
              inputName: 'input_name',
              visible: true,
              disabled: false,
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'number',
              elementLabel: 'Área (ha): ',
              clearable: true
            },
            {
              column: 18,
              type: 'elementInput',
              model: 'imovel.nome',
              inputName: 'input_name',
              visible: true,
              disabled: false,
              validator: 'required',
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'Denominação do Imóvel: ',
              clearable: true
            },
            {
              column: 12,
              type: 'elementInput',
              model: 'imovel.comunidade',
              inputName: 'input_name',
              visible: true,
              disabled: false,
              required: true,
              readonly: false,
              validator: 'required',
              inputType: 'text',
              elementLabel: 'Localização do Imóvel: ',
              clearable: true
            },
            {
              column: 12,
              type: 'elementInput',
              model: 'municipio',
              inputName: 'input_name',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'Município: ',
              clearable: true
            },
            {
              column: 24,
              type: 'elementInput',
              model: 'limites',
              inputName: 'limites',
              visible: true,
              disabled: true,
              required: false,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'Limites: ',
              clearable: true
            }
          ]
        }
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/screens/analise/components/schemaExtratoSentenca/schema.js